/*eslint-disable*/
import './supBookingEdit.css';
import { useParams, useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import DropdownReg from '../../components/dropdownReg/DropdownReg';
import handleChange from '../../utils/handleChange';
import CharCount from '../../components/charCount/CharCount';
import handleNestedChange from '../../utils/handleNestedChange';
import { getOrganizers } from '../../utils/getOrganizers';
import { FetchBookingData, FetchPackList } from './fetchData';
import { supBookingUpdate, supTripOrgDateFun } from '../../api/supportAdmin';
import { getFormattedDateReverse } from '../../utils/date';
import { getDetailsFun } from '../../api/infoAPI';
import { getTaxAmount } from '../../utils/getAmountWithTransaction';
import BookingReadOnly from './BookingReadOnly';
import PriceModel from './PriceModel';
import { toast } from 'react-toastify';

const SupBookingEditTrip = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { state } = useLocation();
    const [bookingData, setBookingData] = useState({});
    const bookingId = searchParams.get('bookingId');
    const orgId = searchParams.get('orgId');
    const packId = searchParams.get('packId');
    const typeBooking = [
        'Same org - Same trip - Different date',
        'Same org - Different trip',
        'Different org - Different trip'
    ];
    const [packData, setPackData] = useState({});
    const [bookingType, setBookingType] = useState('');
    const [orgs, setOrgs] = useState([]);
    const [trips, setTrips] = useState([]);
    const [dates, setDates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedOrg, setSelectedOrg] = useState(null);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [showPrice, setShowPrice] = useState(false);
    const [startCity, setStartCity] = useState([]);
    const [newRoom, setNewRoom] = useState(false);
    const [totalRooms, setTotalRooms] = useState(0);
    const [roomDropDown, setRoomDropDown] = useState([]);

    const [newAmountPaid, setNewAmountPaid] = useState({});
    function handleUser(e, index) {
        const { name, value } = e.target;

        setBookingData((prev) => ({
            ...prev,
            userDetails: prev.userDetails.map((u, i) => (i === index ? { ...u, [name]: value } : u))
        }));
    }
    useEffect(() => {
        FetchBookingData(setBookingData, 'trip', bookingId, setLoading);
        getOrganizers('trip', setOrgs, setLoading);
    }, []);

    useEffect(() => {
        const id = selectedOrg?._id || orgId;
        if (!id) return;
        setSelectedDate('');
        FetchPackList('trip', setTrips, id, 'active', 10, 0, setLoading);
    }, [selectedOrg, orgId]);

    useEffect(() => {
        const tripId = selectedTrip?._id || packId;
        if (!tripId) return;

        const fetchDates = async () => {
            try {
                const res = await supTripOrgDateFun(tripId, 'next');
                if (Array.isArray(res?.data)) {
                    setDates(res.data.sort((a, b) => new Date(a.startDate) - new Date(b.startDate)));
                } else {
                    setDates([]);
                }
            } catch (err) {
                console.error('fetchDates failed:', err?.message ?? err);
                setDates([]);
            }
        };

        fetchDates();
    }, [selectedTrip, packId]);

    useEffect(() => {
        setBookingData((prev) => ({
            ...prev,
            startCity: '',
            pickupLocation: ''
        }));

        const fetchPackData = async () => {
            try {
                const { data } = await getDetailsFun('trip', selectedTrip?._id || packId);
                const city = data?.price?.map((item) => item?.startCity) ?? [];
                setPackData(data ?? {});
                setStartCity(city);
            } catch (err) {
                console.error('fetchPackData failed:', err?.message ?? err);
                setPackData({});
                setStartCity([]);
            }
        };

        fetchPackData();
    }, [selectedTrip, selectedDate]);

    useEffect(() => {
        if (!packData || !bookingData?.startCity) return;

        const matched = packData.price?.find((item) => item.startCity === bookingData.startCity);

        if (!matched) {
            console.warn('No price found for this startCity');
            return;
        }

        const { price } = matched;
        const actual = price.actual * bookingData.totalSeats + (bookingData?.room ? bookingData.room : 0) * totalRooms;
        const tax = getTaxAmount(actual);
        const total = actual + tax;
        const paid =
            bookingData.amountPaid.paid > newAmountPaid.total ? newAmountPaid.total : bookingData.amountPaid.paid;
        const minRooms = Math.ceil(bookingData.totalSeats);
        setRoomDropDown(Array.from({ length: minRooms }, (_, roomIndex) => roomIndex + 1));
        setNewAmountPaid({ actual, tax, total, paid });
    }, [selectedDate, bookingData?.startCity, packData, totalRooms]);

    const startDates = dates.filter(
        (data) => data?.totalSlots !== data?.bookedSlots && data?.startDate !== state?.startDate
    );

    const isRoomAvailable = dates.some((item) => item.totalRooms > item.bookedRooms && item.startDate === selectedDate);
    const cityData = packData?.price?.find((item) => item?.startCity === bookingData?.startCity);

    const optionsForPickup =
        cityData?.pickupLocation?.length > 0
            ? cityData.pickupLocation.map((loc) => loc.name)
            : cityData?.meetupPoint?.map((loc) => loc.name) || [];
    const filteredOrg = orgs.filter((org) => org._id !== orgId);
    const filteredDate = startDates.filter((date) => date);
    const filteredTrip = trips.filter((trip) => trip._id !== packId && trip.datesType === bookingData.datesType);

    const handleSubmit = async () => {
        if (!bookingData.startCity || bookingData.startCity === '' || bookingData.startCity === '-1') {
            toast.warning('Please select start city');
            return;
        }
        if (!bookingData.pickupLocation || bookingData.pickupLocation === '' || bookingData.pickupLocation === '-1') {
            toast.warning('Please select pickup location');
            return;
        }
        let finalData = {
            newStartCity: bookingData.startCity,
            newPickupLocation: bookingData.pickupLocation
        };
        let org_Id;
        if (bookingType === 'Same org - Same trip - Different date') {
            org_Id = orgId;
            finalData = {
                ...finalData,
                newPackDateId: selectedDate?._id,
                org: 'same',
                trip: 'same'
            };
        }

        if (bookingType === 'Same org - Different trip') {
            org_Id = orgId;
            finalData = {
                ...finalData,
                newPackDateId: selectedDate?._id,
                newPackId: selectedTrip?._id,
                org: 'same',
                trip: 'different'
            };
        }

        if (bookingType === 'Different org - Different trip') {
            org_Id = selectedOrg?._id;
            finalData = {
                ...finalData,
                newPackDateId: selectedDate?._id,
                newPackId: selectedTrip?._id,
                newOrganizerId: selectedOrg?._id,
                org: 'different',
                trip: 'different'
            };
        }

        try {
            const result = await supBookingUpdate('trip', bookingId, finalData);
            if (result.status == 200) {
                toast.success('Booking changed successfully');
                navigate(`/support/t/bookings/${org_Id}`);
            }
        } catch (error) {
            console.error('Booking update failed:', error?.response?.data ?? error?.message ?? error);
            toast.error(error?.response?.data?.message ?? 'Something went wrong. Please try again.');
        }
    };

    return (
        <div className='bookingEditDiv'>
            <div className='dropRegDiv'>
                <label className='dropRegLabel'>Type to Change</label>
                <div className='dropRegInputDiv'>
                    <select
                        value={bookingType}
                        name='bookingType'
                        onChange={(e) => {
                            setBookingType(e.target.value);
                            setSelectedDate(null);
                            setSelectedOrg(null);
                            setSelectedTrip(null);
                        }}
                        required={true}
                        className='dropRegSelect'
                    >
                        {' '}
                        <option value=''>Select type</option>
                        {typeBooking.map(function (val, typeIndex) {
                            return (
                                <option key={typeIndex} value={val}>
                                    {val}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
            {/* ================================
   CASE 1 — Same org / Same trip / Different date
================================= */}
            {bookingType === 'Same org - Same trip - Different date' && (
                <div className='dropRegDiv'>
                    <label className='dropRegLabel'>Select Date</label>
                    <div className='dropRegInputDiv'>
                        <select
                            value={selectedDate?._id}
                            onChange={(e) => {
                                const date = startDates.find((o) => o._id === e.target.value);
                                setSelectedDate(date);
                            }}
                            required
                            className='dropRegSelect'
                        >
                            <option value=''>
                                {startDates.length === 0 ? 'No upcoming dates available' : 'Select date'}
                            </option>
                            {startDates.map((val, i) => (
                                <option key={i} value={val._id}>
                                    {getFormattedDateReverse(val.startDate)}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            )}

            {/* ================================
   CASE 2 — Same org / Different trip
================================= */}
            {bookingType === 'Same org - Different trip' && (
                <>
                    {/* Trip dropdown */}
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Select Trip</label>
                        <div className='dropRegInputDiv'>
                            <select
                                value={selectedTrip?._id}
                                onChange={(e) => {
                                    const trip = trips.find((o) => o._id === e.target.value);
                                    setSelectedTrip(trip);
                                }}
                                required
                                className='dropRegSelect'
                            >
                                <option value=''>
                                    {filteredTrip.length === 0 ? 'No upcoming trips available' : 'Select trip'}
                                </option>

                                {filteredTrip.map((val, i) => (
                                    <option key={i} value={val._id}>
                                        {val.title}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Date dropdown — only when trip selected */}
                    {selectedTrip && (
                        <div className='dropRegDiv'>
                            <label className='dropRegLabel'>Select Date</label>
                            <div className='dropRegInputDiv'>
                                <select
                                    value={selectedDate?._id}
                                    onChange={(e) => {
                                        const date = startDates.find((o) => o._id === e.target.value);
                                        setSelectedDate(date);
                                    }}
                                    required
                                    className='dropRegSelect'
                                >
                                    <option value=''>Select date</option>

                                    {startDates.map((val, i) => (
                                        <option key={i} value={val._id}>
                                            {getFormattedDateReverse(val.startDate)}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}
                </>
            )}
            {bookingType === 'Different org - Different trip' && (
                <>
                    {/* Trip dropdown */}
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Select Organzier</label>
                        <div className='dropRegInputDiv'>
                            <select
                                value={selectedOrg?._id || ''}
                                onChange={(e) => {
                                    const org = orgs.find((o) => o._id === e.target.value);
                                    setSelectedOrg(org);
                                    setSelectedDate(null);
                                    setSelectedTrip(null);
                                }}
                                required
                                className='dropRegSelect'
                            >
                                <option value=''>Select Organzier</option>

                                {filteredOrg.map((val, i) => (
                                    <option key={i} value={val._id}>
                                        {val.companyName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {selectedOrg && (
                        <div className='dropRegDiv'>
                            <label className='dropRegLabel'>Select Trip</label>
                            <div className='dropRegInputDiv'>
                                <select
                                    value={selectedTrip?._id || ''}
                                    onChange={(e) => {
                                        const trip = trips.find((o) => o._id === e.target.value);
                                        setSelectedTrip(trip);
                                    }}
                                    required
                                    className='dropRegSelect'
                                >
                                    <option value=''>
                                        {filteredTrip.length === 0 ? 'No upcoming trips available' : 'Select trip'}
                                    </option>

                                    {filteredTrip.map((val, i) => (
                                        <option key={i} value={val._id}>
                                            {val.title}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}

                    {/* Date dropdown — only when trip selected */}
                    {selectedTrip && (
                        <div className='dropRegDiv'>
                            <label className='dropRegLabel'>Select Date</label>
                            <div className='dropRegInputDiv'>
                                <select
                                    value={selectedDate?._id || ''}
                                    onChange={(e) => {
                                        const date = startDates.find((o) => o._id === e.target.value);
                                        setSelectedDate(date);
                                    }}
                                    required
                                    className='dropRegSelect'
                                >
                                    <option value=''>Select date</option>

                                    {startDates.map((val, i) => (
                                        <option key={i} value={val._id}>
                                            {getFormattedDateReverse(val.startDate)}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}
                </>
            )}
            {selectedDate && (
                <>
                    <DropdownReg
                        label='Start City'
                        name='startCity'
                        options={startCity}
                        value={bookingData.startCity}
                        req={true}
                        setFormData={setBookingData}
                    />
                    <DropdownReg
                        label='Pickup Location'
                        name='pickupLocation'
                        options={optionsForPickup}
                        value={bookingData.pickupLocation}
                        req={true}
                        setFormData={setBookingData}
                    />
                    {bookingData?.totalRooms > 0 && isRoomAvailable && (
                        <>
                            <div className='dropRegDiv'>
                                <label className='dropRegLabel'>Do you want to add room for new trip?</label>
                                <div className='dropRegInputDiv radioDiv'>
                                    <label>
                                        <input
                                            type='radio'
                                            name='newRoom'
                                            value='true'
                                            checked={newRoom === true}
                                            onChange={(e) => setNewRoom(true)}
                                        />
                                        Yes
                                    </label>

                                    <label>
                                        <input
                                            type='radio'
                                            name='newRoom'
                                            value='false'
                                            checked={newRoom === false}
                                            onChange={(e) => {
                                                setNewRoom(false);
                                                setTotalRooms(0);
                                            }}
                                        />
                                        No
                                    </label>
                                </div>
                            </div>
                            {newRoom && (
                                <div className='dropRegDiv'>
                                    <label className='dropRegLabel'>Select Rooms</label>
                                    <div className='dropRegInputDiv'>
                                        <select
                                            value={totalRooms}
                                            onChange={(e) => setTotalRooms(e.target.value)}
                                            required
                                            className='dropRegSelect'
                                        >
                                            <option value=''>Select Number of Rooms</option>

                                            {roomDropDown.map((val, i) => (
                                                <option key={i} value={val}>
                                                    {val}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Actual Price</label>
                        <div className='dropRegInputDiv'>
                            <input
                                value={newAmountPaid?.actual ? newAmountPaid?.actual : bookingData?.amountPaid?.actual}
                                name='actual'
                                onChange={(e) => handleNestedChange(e, setBookingData, 'amountPaid')}
                                type='Text'
                                placeholder={`Actual Price`}
                                className='dropRegSelect'
                                disabled={true}
                            ></input>
                        </div>
                    </div>
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Tax</label>
                        <div className='dropRegInputDiv'>
                            <input
                                value={newAmountPaid?.tax ? newAmountPaid?.tax : bookingData?.amountPaid?.tax}
                                name='tax'
                                onChange={(e) => handleNestedChange(e, setBookingData, 'amountPaid')}
                                type='Text'
                                placeholder={`Tax`}
                                className='dropRegSelect'
                                disabled={true}
                            ></input>
                        </div>
                    </div>
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Total</label>
                        <div className='dropRegInputDiv'>
                            <input
                                value={newAmountPaid?.total ? newAmountPaid?.total : bookingData?.amountPaid?.total}
                                name='total'
                                onChange={(e) => handleNestedChange(e, setBookingData, 'amountPaid')}
                                type='Text'
                                placeholder={`Total`}
                                className='dropRegSelect'
                                disabled={true}
                            ></input>
                        </div>
                    </div>
                    <div className='dropRegDiv'>
                        <label className='dropRegLabel'>Paid</label>
                        <div className='dropRegInputDiv'>
                            <input
                                value={newAmountPaid?.paid ? newAmountPaid?.paid : bookingData?.amountPaid?.paid}
                                name='paid'
                                onChange={(e) => handleNestedChange(e, setBookingData, 'amountPaid')}
                                type='Text'
                                placeholder={`Paid`}
                                className='dropRegSelect'
                                disabled={true}
                            ></input>
                        </div>
                    </div>
                    {newAmountPaid?.total &&
                        bookingData?.startCity &&
                        (bookingData?.amountPaid?.paid > newAmountPaid?.total ? (
                            <div className='packEditNote' style={{ marginTop: '30px' }}>
                                <p>
                                    <span style={{ color: 'red', fontWeight: '600' }}>
                                        ₹{bookingData?.amountPaid?.paid - newAmountPaid?.total}
                                    </span>{' '}
                                    will be credited to the customer's account, as the new trip price is lower than the
                                    previous booking.
                                    <span
                                        onClick={() => setShowPrice(true)}
                                        style={{ cursor: 'pointer', color: 'blue' }}
                                    >
                                        Click here to view price details
                                    </span>
                                </p>
                            </div>
                        ) : newAmountPaid?.total === bookingData?.amountPaid?.paid ? (
                            <div className='packEditNote' style={{ marginTop: '30px' }}>
                                <p>
                                    <span style={{ color: 'green', fontWeight: '600' }}>₹0</span> needs to be paid, as
                                    the new trip price is the same as the previous booking.
                                    <span
                                        onClick={() => setShowPrice(true)}
                                        style={{ cursor: 'pointer', color: 'blue' }}
                                    >
                                        Click here to view price details
                                    </span>
                                </p>
                            </div>
                        ) : (
                            <div className='packEditNote' style={{ marginTop: '30px' }}>
                                <p>
                                    <span style={{ color: 'red', fontWeight: '600' }}>
                                        ₹{newAmountPaid?.total - bookingData?.amountPaid?.paid}
                                    </span>{' '}
                                    needs to be paid, as the new trip price is higher than the previous booking.
                                    <span
                                        onClick={() => setShowPrice(true)}
                                        style={{ cursor: 'pointer', color: 'blue' }}
                                    >
                                        Click here to view price details
                                    </span>
                                </p>
                            </div>
                        ))}

                    {/* <div>
                        Since the trip details have changed, the price has also been updated.
                        
                    </div> */}
                    <BookingReadOnly bookingData={bookingData} setBookingData={setBookingData} />
                    <button type='button' className='orgPackUpSubmitBtn blueBtn' onClick={handleSubmit}>
                        Submit
                    </button>
                </>
            )}
            {showPrice && (
                <PriceModel bookingData={bookingData} newAmountPaid={newAmountPaid} setShowPrice={setShowPrice} />
            )}
        </div>
    );
};

export default SupBookingEditTrip;
